import { MedicineApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const medicineApi = new MedicineApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
